const THEME_STORAGE_KEY = 'ilean-theme';
const DARK_THEME_QUERY = '(prefers-color-scheme: dark)';

function getStoredTheme() {
  try {
    const theme = localStorage.getItem(THEME_STORAGE_KEY);
    return theme === 'dark' || theme === 'light' ? theme : null;
  } catch (error) {
    return null;
  }
}

function getSystemTheme() {
  if (typeof window !== 'undefined' && window.matchMedia(DARK_THEME_QUERY).matches) {
    return 'dark';
  }
  return 'light';
}

export function getActiveTheme() {
  return getStoredTheme() || getSystemTheme();
}

export function applyTheme(theme) {
  const activeTheme = theme === 'dark' ? 'dark' : 'light';
  document.documentElement.setAttribute('data-theme', activeTheme);
  document.documentElement.style.colorScheme = activeTheme;
  return activeTheme;
}

export function setTheme(theme) {
  const activeTheme = applyTheme(theme);
  try {
    localStorage.setItem(THEME_STORAGE_KEY, activeTheme);
  } catch (error) {
    // The selected theme still applies for this page when storage is unavailable.
  }
  window.dispatchEvent(new CustomEvent('theme-change', {
    detail: { theme: activeTheme }
  }));
  return activeTheme;
}

export function initializeTheme() {
  const activeTheme = applyTheme(getActiveTheme());
  const mediaQuery = window.matchMedia(DARK_THEME_QUERY);
  const handleSystemThemeChange = (event) => {
    if (!getStoredTheme()) {
      applyTheme(event.matches ? 'dark' : 'light');
      window.dispatchEvent(new CustomEvent('theme-change', {
        detail: { theme: getActiveTheme() }
      }));
    }
  };

  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', handleSystemThemeChange);
  } else {
    mediaQuery.addListener(handleSystemThemeChange);
  }

  return activeTheme;
}

export { THEME_STORAGE_KEY };
